module.exports = __webpack_public_path__ + "img/btn_wallpaper2_thumb.edbfa8ac.png";